import { Button } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";

interface CancelSubscriptionCardProps {
  onCancel: () => void;
}

export const CancelSubscriptionCard = ({
  onCancel,
}: CancelSubscriptionCardProps) => {
  const { t } = useTranslations();

  return (
    <div className="border-dark-100 flex min-h-[144px] w-full max-w-[1000px] items-center justify-between rounded-[18px] border border-solid bg-white px-8 py-6">
      <div className="flex flex-col gap-1">
        <span className="text-dark font-secondary text-xl font-semibold leading-[33px]">
          {t({
            id: "cx-plans-page.cancel-subscription-card.title",
            defaultMessage: "Cancel Subscription",
          })}
        </span>
        <span className="text-dark-700 font-secondary max-w-[520px] text-sm leading-[21px]">
          {t({
            id: "cx-plans-page.cancel-subscription-card.description-canceled",
            defaultMessage:
              "By Canceling Plan - you will loose access to Plan features & Add-ons",
          })}
        </span>
      </div>

      <Button variant="tertiary" onClick={onCancel}>
        {t({
          id: "cx-plans-page.cancel-subscription-card.cancel-button",
          defaultMessage: "Cancel Subscription",
        })}
      </Button>
    </div>
  );
};
